import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-zcams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-zcams.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ViewApplicationLocationZcConstants } from "./view-application-location-zc.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import Polygon from "@arcgis/core/geometry/Polygon";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
let ViewApplicationLocationZcamsComponent = class ViewApplicationLocationZcamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    changeDetectorRefs;
    routerParamsService;
    active;
    propertiesForm;
    descriptionLabel1 = ViewApplicationLocationZcConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationZcConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationZcConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationZcConstants.DESCRIPTION_LABEL_4;
    erfNoControl = ViewApplicationLocationZcConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationZcConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationZcConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationZcConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationZcConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationZcConstants.ADDRESS_CONTROL;
    ownerControl = ViewApplicationLocationZcConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationZcConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationZcConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationZcConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationZcConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationZcConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationZcConstants.ADDRESS_TEXT_PLACEHOLDER;
    ownerLabel = ViewApplicationLocationZcConstants.OWNER_LABEL;
    removePropertyLabel = ViewApplicationLocationZcConstants.REMOVE_PROPERTY_LABEL;
    ownerDisableAdd = true;
    ownerDisableFilterBy = true;
    ownerDisableEditing = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    ownerShowGroupsDropdown = true;
    mapComponent;
    isMapLoaded = false;
    yesNoOptions = [];
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    rcApplication;
    selectedApplicationCMSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.ownerGroups[0].requiredFields = stepMeta.requiredFields;
    }
    handleRouteChange() {
    }
    ngOnInit() {
        this.getMetadata();
        this.initForm();
        this.checkSave();
        this.yesNoOptions = [];
        // tslint:disable-next-line:forin
        for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
            this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
    }
    checkSave() {
        this.selectedApplicationCMSubscription = this.selectedApplicationService.$selectedApplication.subscribe(app => {
            this.rcApplication = app;
            if (this.rcApplication)
                this.syncMapExistingGeometries();
            this.changeDetectorRefs.detectChanges();
        });
    }
    singleFg(prop) {
        const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(prop.shape, 102100));
        const propertyFoemGroup = new FormGroup({
            id: new FormControl(prop.id),
            applicationId: new FormControl(prop.applicationId),
            erfNo: new FormControl(prop.erfNumber),
            subdivision: new FormControl(prop.subdivision),
            allotment: new FormControl(prop.allotment),
            farmNo: new FormControl(prop.farmNumber),
            sgCode: new FormControl(prop.sgCode),
            address: new FormControl(prop.address),
            centroid: new FormControl(null),
            zones: new FormArray([], [Validators.min(1)]),
            owners: new FormControl(null),
            geometry: new FormControl(geom)
        });
        const ownerControl = propertyFoemGroup.get("owners");
        if (this.rcApplication.properties && this.rcApplication.properties.length > 0)
            RecipientUtils.setRecipients(prop.owners, true, ownerControl);
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geom));
        return propertyFoemGroup;
    }
    syncMapExistingGeometries() {
        const pa = this.getProperties();
        if (pa?.controls.length > 0) {
            pa.clear();
        }
        this.rcApplication.properties.forEach((prop) => {
            pa.push(this.singleFg(prop));
        });
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Zone certificate management graphics", true);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationZcamsComponent = __decorate([
    Component({
        selector: "app-view-application-location-zcams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], ViewApplicationLocationZcamsComponent);
export { ViewApplicationLocationZcamsComponent };
